export const mapBrandingSettings = settings => ({
	textAlignment: settings?.text_alignment,
	logoAlignment: settings?.logo_alignment,
	colorHeader: settings?.header_footer_color,
	colorBackground: settings?.background_color,
	colorText: settings?.text_color,
	applySetting: settings?.apply_settings,
	publicLogoUrl: settings?.public_logo_url,
	supportingMessage: settings?.supporting_message,
});
